import { isObject } from 'lodash'

export function filterStr({ row, column, cellValue, index }) {
  if (cellValue === null || cellValue === undefined || cellValue === '') {
    return '-'
  } else {
    return cellValue
  }
}

export default {
  methods: {
    // vxe-grid formatter
    filterStr,
    // 得到 排序数据
    getSortData() {
      if (!this.$refs.MainContainer) {
        return []
      }

      const sortData = this.$refs.MainContainer.getSortColumns()
      const ret = (sortData || []).map(item => {
        const { property, order } = item
        return {
          property,
          order
        }
      })
      return ret || []
    },
    // 手动刷新表格
    flushTableData(isShowLoading = true, isResetPageSize = false) {
      if (!this.$refs.MainContainer) {
        return
      }

      this.$nextTick(() => {
        if (isShowLoading && isResetPageSize) {
          this.$refs.MainContainer.getFirstPageData()
        } else if (isShowLoading && !isResetPageSize) {
          this.$refs.MainContainer.getData()
        } else if (!isShowLoading && isResetPageSize) {
          console.log('todo, 没有实现')
        } else if (!isShowLoading && !isResetPageSize) {
          this.$refs.MainContainer.getDataWithoutLoading()
        }
      })
    },
    // 处理 column.property 对应字段的 金额表示方式
    formatterMoney({ row, column }) {
      const currencySymbol = row.currencySymbol
      const amount = row[column.property]

      if (amount === null || amount === undefined || amount === '') {
        return '-'
      }

      return currencySymbol + this.$utils.commaNum(amount, 2)
    },
    formatterObjMoney({ row, column }) {
      const amount = row[column.property].amount
      const currencySymbol = row[column.property].currencySymbol

      if (amount === null || amount === undefined || amount === '') {
        return '-'
      }

      return currencySymbol + this.$utils.commaNum(amount, 2)
    },
    initDefaultFormConfigFromQuery() {
      try {
        const { defaultFormConfig } = this.$route.query
        const config = JSON.parse(defaultFormConfig)

        if (isObject(config)) {
          Object.entries(config).forEach(([key, item]) => {
            if (this.formConfig[key]) {
              // assign value
              if (item.value !== undefined) {
                this.formConfig[key].value = item.value
              }
              // assign selectValue
              if (item.selectValue !== undefined) {
                this.formConfig[key].selectValue = item.selectValue
              }
            }
          })
        }
      } catch (err) {

      }
    },
    // 组装 headers , 合并 this.tableColumns[field] 里面的数据
    headersToHeadersProps(columns) {
      return columns.map(col => {
        const { label, field, fixed, children, ...rest } = col
        const ret = {
          ...rest,
          title: label,
          field,
        }

        if (fixed === 1) {
          ret.fixed = 'left'
        } else if (fixed === 2) {
          ret.fixed = 'right'
        }

        if (this.tableColumns[field]) {
          Object.assign(ret, this.tableColumns[field])
        }

        if (Array.isArray(children)) {
          ret.children = this.headersToHeadersProps(children)
        }

        return ret
      })
    },
  }
}
